import React, { useState } from 'react'
import classNames from 'classnames'

import { Centre, WithNavigationMenu } from '../types'
import {
  CONFIG_KEYS,
  getClientConfigValue,
} from '../../../helpers/config-helper'
import style from './index.scss'
import { CentreSelector } from './centre-selector'
import Nav from '.'

const Main: React.FC<{
  country: string
  centres?: Array<Centre>
  centre?: Centre
  shop?: WithNavigationMenu
  giftCards?: WithNavigationMenu
  onClose: () => void
}> = ({ country, centres, centre, shop, giftCards, onClose }) => {
  const [path, setPath] = useState<Array<number>>([])

  const findACentreNodes =
    centres &&
    (() => {
      const centresByRegion = centres.reduce<{ [key: string]: Array<Centre> }>(
        (acc, c) => {
          let arr = acc[c.state]
          if (!arr) {
            arr = []
            acc[c.state] = arr
          }
          arr.push(c)
          return acc
        },
        {}
      )

      return [
        () => <CentreSelector centres={centres} centre={centre} />,
        () => (
          <div className={classNames(style.subtitle, style.regions)}>
            Regions
          </div>
        ),
        ...(country === 'New Zealand'
          ? [
              ['AUCKLAND', 'Auckland'],
              ['CHRISTCHURCH', 'Christchurch'],
            ]
          : [
              ['ACT', 'Australian Capital Territory'],
              ['NSW', 'New South Wales'],
              ['QLD', 'Queensland'],
              ['SA', 'South Australia'],
              ['VIC', 'Victoria'],
              ['WA', 'Western Australia'],
            ]
        )
          .filter(([key]) => centresByRegion[key])
          .map(([key, title]) => ({
            title,
            items: centresByRegion[key].map(c => ({
              label: c.title,
              url: `/${c.slug}`,
            })),
          })),
      ]
    })()

  const items = [
    shop?.navigationMenu?.length
      ? {
          title: 'Shop online',
          items: shop.navigationMenu,
          className: classNames(style['item-big']),
        }
      : undefined,
    centre
      ? {
          title: centre.title,
          hideTitle: true,
          items: [
            () => (
              <div className={classNames(style.item)}>
                <div className={classNames(style.title)}>{centre.title}</div>
                <button
                  className={classNames(style.link)}
                  onClick={() =>
                    setPath([
                      items.findIndex(
                        item =>
                          item &&
                          'title' in item &&
                          item.title === 'Find a centre'
                      ),
                    ])
                  }
                >
                  Change
                </button>
              </div>
            ),
            ...centre.navigationMenu,
          ],
          className: classNames(style['item-big']),
        }
      : findACentreNodes && {
          title: 'Find a centre',
          items: findACentreNodes,
          className: classNames(style['item-big']),
        },
    giftCards && {
      title: 'Gift Cards',
      items: giftCards.navigationMenu,
      className: classNames(style['item-big']),
    },
    // {
    //  label: 'The Edit',
    //  url: '/the-edit',
    //  className: classNames(style['item-big']),
    // },
    {
      label: 'Westfield Plus',
      url: '/westfield-plus',
      target: '_blank',
      className: classNames(style['item-big']),
    },
    centre &&
      findACentreNodes && {
        title: 'Find a centre',
        items: findACentreNodes,
      },
    {
      label: 'Customer Support',
      url:
        country === 'New Zealand'
          ? 'https://support.westfield.co.nz'
          : 'https://support.westfield.com.au',
    },
  ]

  return <Nav items={items} path={path} onClose={onClose} />
}

export default Main
